import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Close from "../../assets/images/close-icon.png";
import Typography from "@mui/material/Typography";
import "../../components/common/css/datatable.scss";
import { usePermissions } from "../../context/permissionContext";
import { validatePermission } from "../../utils/permissionUtils";
import Box from "@mui/material/Box";
import axios from "axios";
import Swal from "sweetalert2";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { useForm } from "react-hook-form";
import Select from "react-select";
import Loader from "../../components/Loader/Loader";
import PageShell from "../../components/layout/PageShell";
import PageHead from "../../components/layout/PageHead";

const Commission = () => {
  const [query, setQuery] = useState("");

  const [open, setOpen] = useState(false);
  const [countryID, setCountryID] = useState();
  const [countries, setCountries] = useState();
  const [getCountry, setCountry] = useState([]);

  const handleOpen = (row) => {
    setOpen(true);
    setID(row?.id);
    setCommissionValue(row?.commission?.values);
    setCommissionID(row?.users?.id);
  };
  const handleClose = () => setOpen(false);
  const [employees, setEmployees] = useState([]);
  const [commissionValue, setCommissionValue] = useState();
  const [commissionID, setCommissionID] = useState();

  const [id, setID] = useState();

  const [loading, setLoading] = useState(false);
  const [pageState, setPageState] = useState({
    data: [],
    total: 0,
    page: 1,
    pageSize: 9,
  });
  const { permissions, permissionsMapping } = usePermissions();

  useEffect(() => {
    fetchComissionData();
  }, [pageState.page, pageState.pageSize, query]);

  const fetchComissionData = (country_id) => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    setPageState((old) => ({ ...old }));
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "get-list-of-employees",
      headers: {
        "x-access-token": token,
      },

      data: {
        page: pageState.page,
        limit: pageState.pageSize,
        country_id: country_id,
      },
    };

    axios(config)
      .then(function (response) {
        console.log("response", response);
        setLoading(false);
        setPageState((old) => ({
          ...old,
          data: response.data.data.rows,
          total: response.data.data.count,
        }));
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error?.response?.data?.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };
  useEffect(() => {
    fetchCountries();
  }, []);

  const fetchCountries = () => {
    let token = localStorage.getItem("accessToken");
    var config = {
      method: "get",
      url: process.env.REACT_APP_API + "get-country",
      headers: {
        "x-access-token": token,
      },
    };

    axios(config)
      .then(function (response) {
        const data = response.data.data;
        const options = data.map((d) => ({
          value: d.id,
          label: d.country_name,
        }));

        setCountries(options);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleChangeCountry = (e) => {
    setCountryID(e.value);
    setCountry(e);
    fetchComissionData(e.value);
  };

  const hasEditPermission = validatePermission(
    "Users Management - Manage Commissions:Edit",
    permissions,
    permissionsMapping
  );

  const requestColumn = [
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      minWidth: 160,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            {hasEditPermission && (
              <div
                className="editButton"
                onClick={() => handleOpen(params.row)}
              >
                <EditOutlinedIcon />
              </div>
            )}
          </div>
        );
      },
    },
  ];

  const userColumns = [
    { field: "e_id", headerName: "ID", width: 100 },
    {
      field: "user",
      headerName: "FirstName",
      flex: 1,
      minWidth: 250,
      renderCell: (params) => {
        const d = params.row.users;
        console.log("d--value", d);
        return <span>{d?.firstname}</span>;
      },
    },
    {
      field: "users",
      headerName: "LastName",
      flex: 1,
      minWidth: 250,
      renderCell: (params) => {
        const d = params.row.users;
        return <span>{d?.lastname}</span>;
      },
    },

    {
      field: "designation",
      headerName: "Designation",
      flex: 1,
      minWidth: 250,
      renderCell: (params) => {
        const d = params.row.designation;
        // const d = new Date(params.row.updatedAt);
        return <span>{d?.designation}</span>;
      },
    },

    {
      field: "country",
      headerName: "Country",
      flex: 1,
      minWidth: 250,
      renderCell: (params) => {
        const d = params.row.country;
        // const d = new Date(params.row.updatedAt);
        return <span>{d?.country_name}</span>;
      },
    },
    {
      field: "comission",
      headerName: "Commission",
      flex: 1,
      minWidth: 250,
      renderCell: (params) => {
        let commission_value = params?.row?.commission;
        return <span>{commission_value?.values}</span>;
      },
    },
  ];

  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
  });
  const updateCommissionValue = (e) => {
    let getCommissionValue = e.target.value;
    if (
      !getCommissionValue ||
      getCommissionValue.match(/^\d{1,}(\.\d{0,4})?$/)
    ) {
      setCommissionValue(getCommissionValue);
    }
  };
  const submitCommission = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    var config = {
      method: "patch",
      url: process.env.REACT_APP_API + "update-commission",
      headers: {
        "x-access-token": token,
      },
      data: {
        //  c_id: id,
        user_id: commissionID,
        values: commissionValue,
        format: "percentage",
        status: 1,
      },
    };
    axios(config)
      .then(function (response) {
        if (response.data.status == 200) {
          setLoading(false);
          setOpen(false);
          Swal.fire({
            title: "Commission Updated Successfully",
            timer: 2500,
            timerProgressBar: true,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
          });
        }
        setOpen(false);
        fetchComissionData();

        // setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        if (error?.response?.data?.message) {
          Swal.fire({
            title: "Error",
            timer: 2500,
            timerProgressBar: true,
            text: error?.response?.data?.message,
            icon: "error",
            confirmButtonColor: "#f27474",
            confirmButtonText: "OK",
            dangerMode: true,
            showCloseButton: true,
          });
        }
      });
  };

  return (
    <PageShell><PageHead title="Commissions" /><div className="list">
      <div className="listContainer">

        <div className="datatable">
          <Loader isLoading={loading} />

          <h5 className="h5Title" style={{ textAlign: "center" }}>
            Commision
          </h5>
          <div className="formInput">
            <label>Reporting Country</label>
            <Select
              options={countries}
              onChange={handleChangeCountry}
              value={getCountry}
            />
          </div>
          <DataGrid
            className="datagrid"
            autoHeight
            rows={pageState.data}
            rowCount={pageState.total}
            rowsPerPageOptions={[10, 30, 50, 70, 100]}
            pagination
            page={pageState.page - 1}
            pageSize={pageState.pageSize}
            paginationMode="server"
            onPageChange={(newPage) => {
              setPageState((old) => ({ ...old, page: newPage + 1 }));
            }}
            onPageSizeChange={(newPageSize) =>
              setPageState((old) => ({ ...old, pageSize: newPageSize }))
            }
            columns={userColumns.concat(requestColumn)}
          />
        </div>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="modal-popup">
            <div className="modal-top">
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Update Commission
              </Typography>
              <Button className="closeBtn" onClick={() => setOpen(false)}>
                <img src={Close} alt="close-icon" />
              </Button>
            </div>
            <Typography id="modal-modal-description" sx={{ mt: 1 }}>
              <div className="new">
                <div className="newContainer">
                  <div
                    className="bottom"
                    style={{ boxShadow: "none", padding: "0" }}
                  >
                    <div className="right">
                      <form className="accredited-investorForm">
                        <div className="formInput" id="commissionInput">
                          <label>Commission</label>
                          <input
                            type="number"
                            name="commission"
                            placeholder="Enter Commission Value"
                            value={commissionValue}
                            min="0.5"
                            max="1.5"
                            onChange={updateCommissionValue}
                          />
                          {errors.name && (
                            <div className="invalid-feedback">
                              {errors.name.message}
                            </div>
                          )}
                        </div>

                        <div className="item accreditedItem">
                          <div className="details profile-info">
                            <div className="submitButton">
                              <button
                                className="approveButton"
                                type="button"
                                disabled={!commissionValue}
                                onClick={submitCommission}
                              >
                                Update
                              </button>

                              <button
                                className="cancelButton"
                                type="button"
                                onClick={() => setOpen(false)}
                              >
                                Close
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </Typography>
          </Box>
        </Modal>
      </div>
    </div></PageShell>
  );
};

export default Commission;
